import React, { useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { MessagesContext } from "../../context/messages";
import { messagesFetcher } from "../../api/requests";

const Blank = () => {
  const { messages } = useContext(MessagesContext);

  useEffect(() => {
    if (!messages?.results?.length) return;

    const timer = setTimeout(async () => {
      try {
        await messagesFetcher.post(); 
      } catch (error) {
        console.error("Failed to fetch messages:", error);
      }
    }, 0); 

    return () => clearTimeout(timer);
  }, [messages]);

  const alerts =
    messages?.results?.length > 0 ? (
      messages?.results?.map((item, idx) => (
        <Alert
          key={idx}
          variant={item?.is_read === true ? "secondary" : "success"}
        >
          {item?.message}
        </Alert>
      ))
    ) : (
      <p>شما پیامی ندارید.</p>
    );

  return (
    <ContentWrapper>
      <Container fluid style={{ padding: "30px", textAlign: "-webkit-center" }}>
        <div
          className="video-block section-padding"
          style={{
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col md={12}>
              <SectionHeader heading="پیام ها" />
            </Col>
            <Col md={12} style={{ textAlign: "right" }}>
              {alerts}
            </Col>
          </Row>
        </div>
      </Container>
    </ContentWrapper>
  );
};

export default Blank;
